<template>
  <b-modal
    id="reviewOnboardingDoc"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    :visible="showConfirm"
    @hidden="$emit('close-modal')"
  >
    <main class="d-flex w-100">
      <div class="modal-left-blue"></div>
      <div style="width: calc(100% - 65px)">
        <div class="d-flex align-items-start justify-content-between p-3">
          <div>
            <h5 class="b-modal-header">Review On-Boarding Documents</h5>
            <h6 class="modal-grey-txt mb-0">Accept and Reject Documents</h6>
          </div>
          <div class="rotate-on-hover pointer">
            <img
              @click="$emit('close-modal')"
              v-b-tooltip.hover.top="'Close'"
              src="@/assets/img/accessconnew/blueCross.svg"
              alt
            />
          </div>
        </div>
        <hr class="my-0" />

        <div class="ondoc-modal-overflow p-4">
          <div v-if="acceptedDocsByType(0).length != 0" class="d-flex w-100">
            <section class="w-60">
              <div class="d-flex align-items-center ondoc-black-txt">
                <img
                  class="mr-2"
                  src="@/assets/OnboardingDoc/red-cross.svg"
                  alt
                />
                Rejected Documents
              </div>
              <div class="d-flex flex-wrap gap-2 mt-2">
                <article
                  v-for="(i, index) in acceptedDocsByType(0)"
                  :key="i + index"
                  class="ondoc-rejected-tag"
                >
                  {{ i }}
                </article>
              </div>
            </section>
            <section v-if="true" class="ondoc-textarea-box w-40">
              <div class="newmodalinputbox position-relative">
                <label class="pff-add-left-main-headings">
                  Remarks on Rejected Documents
                  <span class="asterik">*</span>
                </label>
                <CustomQuillEditor
                  @select-value="rejectedRemarks = $event"
                  v-model.trim="$v.rejectedRemarks.$model"
                  :content="$v.rejectedRemarks.$model"
                  :type="'text'"
                  :mandatory="false"
                  :placeholder="''"
                  :id="'101'"
                  :showError="$v.rejectedRemarks.$error"
                />
                <!-- <b-form-textarea
                  v-model.trim="$v.rejectedRemarks.$model"
                  no-resize
                  :class="{
                    error: $v.rejectedRemarks.$error,
                  }"
                  placeholder="Enter"
                ></b-form-textarea> -->
                <div
                  class="errortxt position-absolute"
                  v-if="
                    $v.rejectedRemarks.$dirty && !$v.rejectedRemarks.required
                  "
                >
                  Required
                </div>
                <div
                  v-else-if="$v.rejectedRemarks.$error"
                  class="errortxt position-absolute"
                >
                  Exceeded max char length of 256
                </div>
              </div>
            </section>
          </div>
          <hr
            v-if="
              acceptedDocsByType(0).length != 0 &&
              acceptedDocsByType(1).length != 0
            "
            class="my-4"
          />
          <div v-if="acceptedDocsByType(1).length != 0" class="d-flex w-100">
            <section :class="{ 'w-60': acceptedDocsByType(0).length == 0 }">
              <div class="d-flex align-items-center ondoc-black-txt">
                <img
                  class="mr-2"
                  src="@/assets/OnboardingDoc/green-tick.svg"
                  alt
                />
                Accepted Documents
              </div>
              <div class="d-flex flex-wrap gap-2 mt-2">
                <article
                  v-for="(i, index) in acceptedDocsByType(1)"
                  :key="i + index"
                  class="ondoc-accepted-tag"
                >
                  {{ i }}
                </article>
              </div>
            </section>
            <section
              v-if="acceptedDocsByType(0).length == 0"
              class="ondoc-textarea-box w-40"
            >
              <div class="newmodalinputbox position-relative">
                <label class="pff-add-left-main-headings">Remarks</label>
                <!-- <b-form-textarea
                  v-model.trim="remarks"
                  no-resize
                  placeholder="Enter"
                ></b-form-textarea> -->
                <!-- <div
                  v-if="$v.remarks.$error"
                  class="errortxt position-absolute"
                >
                  Exceeded max char length of 256
                </div> -->
                <CustomQuillEditor
                  @select-value="remarks = $event"
                  v-model="remarks"
                  :content="remarks"
                  :type="'text'"
                  :mandatory="false"
                  :placeholder="''"
                  :id="'101'"
                />
              </div>
            </section>
          </div>
        </div>

        <hr class="my-0" />
        <div class="d-flex align-items-center justify-content-end p-3 w-100">
          <div class="d-flex align-items-center bluebtn">
            <b-button
              class="acs-cancelBtn-modal mr-3"
              @click="$emit('close-modal')"
              >Cancel</b-button
            >
            <div class="position-relative">
              <b-button
                class="acs-addBtn-modal pl-4 pr-4"
                :class="
                  LoaderStatus
                    ? 'confirm-loader-class defaultCursor'
                    : 'pointer'
                "
                @click="confirmAcptRjct()"
                >{{ LoaderStatus ? "" : "Confirm" }}</b-button
              >
              <div v-if="LoaderStatus" class="confirm-loader-pos">
                <Loader />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </b-modal>
</template>

<script>
import { requiredIf } from "vuelidate/lib/validators";
import { acptRjctKanbanDocs } from "../../../utils/apiFunctions";
import toast from "../../../components/mixin/toast";
import Loader from "../../../components/fixedcomponents/Loader.vue";
import CustomQuillEditor from "../../../components/InputComponents/CustomQuillEditor.vue";

export default {
  name: "ConfirmDocsModal",
  data() {
    return {
      rejectedRemarks: null,
      remarks: null,
      LoaderStatus: false,
    };
  },
  props: {
    showConfirm: Boolean,
    documentData: Object,
    acceptedDocsByType: {
      type: Function,
      required: true,
    },
  },
  mixins: [toast],
  components: { Loader, CustomQuillEditor },
  validations: {
    rejectedRemarks: {
      required: requiredIf(function () {
        return this.acceptedDocsByType(0).length != 0;
      }),
      // maxLength: maxLength(256),
    },
    // remarks: {
    //   maxLength: maxLength(256),
    // },
  },
  methods: {
    getOverallStatus(fields) {
      let status;
      let documentStatuses = fields
        .filter((field) => "documentStatus" in field)
        .map((field) => field.documentStatus);
      if (documentStatuses.includes(0)) status = 0;
      else status = 1;
      return status;
    },
    async confirmAcptRjct() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.LoaderStatus = true;
        try {
          let fieldData = JSON.parse(JSON.stringify(this.documentData.fields));
          fieldData = fieldData.map((obj) => {
            if ("localDocStatus" in obj) {
              obj.documentStatus = obj.localDocStatus;
              delete obj.localDocStatus;
            }
            if ("multiFields" in obj) delete obj.multiFields;
            if ("selectedIndex" in obj) delete obj.selectedIndex;
            if ("protected" in obj) delete obj.protected;
            if ("show" in obj) delete obj.show;
            return obj;
          });
          let payload = {
            jobID: this.$route.params.jobID,
            candidateID: this.$route.params.candidateID,
            remark:
              this.acceptedDocsByType(0).length != 0
                ? this.rejectedRemarks
                : this.remarks,
            fields: fieldData,
            status: this.getOverallStatus(fieldData),
          };
          console.log("payload", payload);
          const res = await acptRjctKanbanDocs(payload);
          if (res.status == 200) {
            this.$emit("close-modal");
            this.$emit("success");
            this.dynamicToast("success", "Submitted successfully.", "");
          } else {
            this.errorModal("Something went wrong!");
          }
        } catch (error) {
          console.error(error);
          this.errorModal("Something went wrong!");
        } finally {
          this.LoaderStatus = false;
        }
      }
    },
  },
};
</script>

<style>
.modal-left-blue {
  background-color: #20639b;
  width: 65px;
  border-radius: 10px 0px 0px 10px;
}
#reviewOnboardingDoc .modal-body {
  padding: 0;
}
#reviewOnboardingDoc .modal-dialog {
  max-width: 1045px;
}
.modal-grey-txt {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: #7a7a7a;
}
.ondoc-rejected-tag {
  height: 31px;
  background: #eb00021a;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #eb0002;
  border-radius: 25px;
  display: flex;
  align-items: center;
  padding-inline: 7px;
}
.ondoc-accepted-tag {
  height: 31px;
  background: #038e0029;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #038e00;
  border-radius: 25px;
  display: flex;
  align-items: center;
  padding-inline: 7px;
}
.gap-2 {
  gap: 10px;
}
.ondoc-textarea-box {
  width: 380px;
  padding-right: 60px;
  flex-shrink: 0;
}
.ondoc-modal-overflow {
  height: calc(100vh - 400px);
  max-height: 460px;
  overflow: auto;
}
</style>
